import { apiFetch } from './client';

// #152 — in-portal bug reporting. Staff submit a report from the Help page;
// the API opens a GitHub issue on the portal repo and returns its number + URL.
// 503s with "bug reporting not configured" until the github-bugreport-token is
// staged; the modal surfaces that as a plain not-configured message.

export interface BugReportInput {
  title: string;
  description: string;
  // Auto-attached client context. Never a token — page + UA only; the server
  // attaches the authoritative submitter identity and role from the token.
  page?: string;
  userAgent?: string;
}

export interface BugReportResult {
  number: number;
  htmlUrl: string;
}

export async function submitBugReport(input: BugReportInput): Promise<BugReportResult> {
  return apiFetch<BugReportResult>('/feedback', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
